// もっとみる形式リスト、デフォルト件数
export const FOOTBALLLOG_MONTH_LIMIT = 7;
export const GBNS_LIMIT = 5;
export const GBN_FEEDS_LIMIT = 7;
export const GOALS_LIMIT = 10;
export const SUPPORTERS_LIMIT = 20;
export const SUPPORTER_REQUESTS_LIMIT = 10;
export const COMMENTS_LIMIT = 20;
export const VIDEOS_LIMIT = 10;
export const VIDEOS_GRID_LIMIT = 9;
export const PAYMENTS_LIMIT = 20;
export const TEAM_MEMBERS_LIMIT = 10;

// ページング表示
export const MAX_VISIBLE_PAGES = 5;

// 通知
export const MAX_DISPLAYED_NOTIFICATION = 10;

// アプリバージョン ローカルストレージキー
export const LOCAL_STORAGE_KEY_APP_VERSION = 'appversion';

// 通知 ローカルストレージキー
export const LOCAL_STORAGE_KEY_NOTIFICATION = 'notifications';

// サッカーボード ローカルストレージキー
export const LOCAL_STORAGE_KEY_TACTICALBOARD = 'tacticalBoard';
export const LOCAL_STORAGE_KEY_TACTICALBOARD_V2 = 'tacticalBoardSaves';

// 検索キーワード履歴 ローカルストレージキー
export const LOCAL_STORAGE_KEY_SEARCH_KEYWORD = 'searchKeywords';

// オンボーディング Cookieキー
export const COOKIE_KEY_ONBOARDING = 'fl_ob';

// チームページオンボーディング Cookieキー
export const COOKIE_KEY_TEAM_ONBOARDING = 'fl_team_ob';
